import React from 'react';
import DiagnosisChart from '../Common/WellDiagnosisChart';
import { mapXYArrays } from '../../../utilities/DiagnosisHelper';

interface PumpData {
  [key: string]: any;
  ChartTitle?: string;
}

interface PumpCurveChartProps {
  chartData: Array<{ data?: PumpData }> | null;
  parameters: any;
}

const extractLabel = (chartData: PumpCurveChartProps['chartData']) => {
  if (!Array.isArray(chartData)) return '';

  let prefix = '';
  const stages: string[] = [];

  chartData.forEach((pump) => {
    const title = pump?.data?.ChartTitle;
    if (!title) return;

    const parts = title.split(' - ');
    if (parts.length > 1) {
      if (!prefix) prefix = parts[0].trim() + ' -';
      stages.push(parts.slice(1).join(' - ').trim());
    } else {
      stages.push(title.trim());
    }
  });

  return prefix ? `${prefix} ${stages.join(' + ')}` : stages.join(' + ');
};

const PumpCurveChart: React.FC<PumpCurveChartProps> = ({ chartData, parameters }) => {
  const combinedLabel = extractLabel(chartData);

  const keysToCombine = parameters.map((cfg: any) => cfg.key);
  const combinedData: Record<string, any> = {};
  if (Array.isArray(chartData)) {
    keysToCombine.forEach((key: any) => {
      const arrays = chartData.map((pump) => pump?.data?.[key]).filter((arr) => Array.isArray(arr));
      const flatObj = { [key]: arrays.flat() };
      combinedData[key] = mapXYArrays(flatObj, [key])[key];
    });
  }

  return (
    <DiagnosisChart
      chartData={combinedData}
      seriesConfig={parameters}
      widgetHeader='Pump curve'
      xAxisLabel='Average pump flow rate (rb/day)'
      yAxisLabel='Total head (ft)'
      chartLabel={combinedLabel}
    />
  );
};

export default PumpCurveChart;
